import { PhoneNumberWithPrefix } from '../containers/phone-number-with-prefix/phone-number-with-prefix';
import { PhoneNumberWithPrefixRequest } from '../api/requests/phone-number-with-prefix.request';

export const phoneNumberWithPrefixToRequest = (
  phoneNumberWithPrefix: PhoneNumberWithPrefix,
): PhoneNumberWithPrefixRequest => {
  return new PhoneNumberWithPrefixRequest({
    number: phoneNumberWithPrefix.number,
    prefix: phoneNumberWithPrefix.prefix,
  });
};
